export default {
    beforeDraw: function (chart) {
        if (chart.config.options.elements.center) {
            //Get ctx from string
            var ctx = chart.chart.ctx;

            //Get options from the center object in options
            var centerConfig = chart.config.options.elements.center;
            var fontStyle = '"Roboto", sans-serif';
            var txt = centerConfig.text;
            var title = centerConfig.title;
            var colorText = centerConfig.color || '#000';
            var colorTitle = '#394956';
            var sidePadding = centerConfig.sidePadding || 20;
            var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
            //Start with a base font of 30px
            ctx.font = "40px " + fontStyle;

            //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
            var stringWidth = ctx.measureText(txt).width;
            var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

            // Find out how much the font can grow in width.
            var widthRatio = elementWidth / stringWidth;
            var newFontSize = Math.floor(30 * widthRatio);
            var elementHeight = (chart.innerRadius * 2);

            // Pick a new font size so it will not be larger than the height of label.
            var fontSizeToUse = Math.min(newFontSize, elementHeight);
            //Set font settings to draw it correctly.
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
            var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
            ctx.font = Math.floor(fontSizeToUse / 3) + "px " + fontStyle;
            ctx.fillStyle = colorTitle;

            //Draw text in center
            ctx.fillText(title, centerX, centerY - (fontSizeToUse / 2));
            ctx.font = fontSizeToUse + "px " + fontStyle;
            ctx.fillStyle = colorText;
            ctx.fillText(txt, centerX, centerY + (fontSizeToUse / 2));
        }
    }
}